import React, { Fragment } from "react";
import * as styles from "../newStyles.styles";
import { videoSections } from "../../constants";
import Header from "../Header";
import Footer from "../Footer";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Tutorials({ history }) {
  let location = useLocation();
  const isProtectedReq = location.pathname === "/user-tutorials";
  const goBack = () => {
    history.push("/application");
  };
  const renderVideoSections = videoSections.map((videoSection) => {
    return (
      <Fragment key={videoSection.sectionName}>
        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <styles.ColoredH4>{videoSection.sectionName}</styles.ColoredH4>{" "}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            {videoSection.videos.map((videoRow) =>
              videoRow.map((video) => {
                return (
                  <div
                    key={video.videoName}
                    className={styles.col + " " + styles.col_xs}
                  >
                    <iframe
                      className={styles.frameStyle}
                      height="300"
                      src={video.youtubeLink}
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen={true}
                      frameBorder="0"
                    ></iframe>
                    <styles.P style={{ textAlign: "center", fontSize: "20px" }}>
                      {video.videoName}
                    </styles.P>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Fragment>
    );
  });

  return (
    <div className={styles.body}>
      <div className={styles.wrapper}>
        {isProtectedReq ? (
          <div className={styles.storeContainer}>
            <FontAwesomeIcon
              className={styles.arrowStyle}
              icon="arrow-left"
              onClick={goBack}
            />
          </div>
        ) : (
          <Header history={history} />
        )}

        <styles.H2
          style={{ textAlign: "center", margin: "30px 0px", width: "100%" }}
        >
          We can show you the ropes!
        </styles.H2>

        {renderVideoSections}
        {isProtectedReq ? null : <Footer />}
      </div>
    </div>
  );
}

export default Tutorials;
